import { useContext } from 'react';

export const useSafeContext = (context) => {
  const contextValue = useContext(context);
  if (!contextValue) {
    throw new Error('context is not available');
  }
  return contextValue;
};
